import styles from './tooltip-view.module.css';

interface ToolTipViewProps {
    title: string;
    secondaryTitle?: string;
}

export function ToolTipView({ title, secondaryTitle }: ToolTipViewProps) {
    return (
        <div className={styles['tooltip-view']}>
            <div className={styles['tooltip-view--title']}>{title}</div>
            {secondaryTitle ? (
                <>
                    <div className={styles['tooltip-view--divider']} />
                    <div className={styles['tooltip-view--secondary-title']}>{secondaryTitle}</div>
                </>
            ) : null}
        </div>
    );
}
